import { render } from "./KnowYourPropertyComponent.vue?vue&type=template&id=9eab1e4a&scoped=true&ts=true"
import script from "./KnowYourPropertyComponent.vue?vue&type=script&lang=ts"
export * from "./KnowYourPropertyComponent.vue?vue&type=script&lang=ts"

import "./KnowYourPropertyComponent.vue?vue&type=style&index=0&id=9eab1e4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eab1e4a"]])

export default __exports__